import 'react-datepicker/dist/react-datepicker.css';

import {
  ActionStyledAsButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogHeader,
  linkFocusStyles,
  linkHoverStyles,
} from '@ftrprf/tailwind-components';
import useFormatMessage from 'hooks/useFormatMessage';
import { dataTestIds } from 'utils/dataTestIds';
import c from '@ftrprf/tailwind-components/src/utils/c';

export function FakeQuickPlanDialog({ isOpen, onClose = () => {} }) {
  const t = useFormatMessage();

  return (
    <Dialog
      data-test={dataTestIds.modal.quickPlan.self}
      isOpen={isOpen}
      modal
      onDismiss={onClose}
    >
      <DialogHeader hasCloseButton onDismiss={onClose}>
        <div className="mr-4">
          {t('demo.superlight.modal.fake.quickplan.title')}
        </div>
      </DialogHeader>

      <DialogContent className="m-0 pb-24">
        {t('demo.superlight.modal.fake.quickplan.content')}
        <a
          className={c(
            linkFocusStyles,
            linkHoverStyles,
            'hover:text-accent-500 hover:decoration-dashed underline',
          )}
          href="https://demo.ftrprf.be/#request-form"
          rel="noopener noreferrer"
          target="_blank"
        >
          demo.ftrprf.be
        </a>
        .
      </DialogContent>
      <DialogActions>
        <ActionStyledAsButton onClick={onClose}>
          {t('global.close')}
        </ActionStyledAsButton>
      </DialogActions>
    </Dialog>
  );
}
